// src/components/guards/AdminGuard.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const AdminGuard = ({ children }) => {
    const { user, loading } = useAuth();
    if (loading) {
        return <div>Loading...</div>;
    }
    if (!user || !['super_admin', 'admin'].includes(user.role)) {
        return <Navigate to="/dashboard" replace />;
    }
    return children;
};

export default AdminGuard;